import {
  AUCTION_UPGRADES_TYPES,
  STORE_TYPES,
  CATEGORIES_TYPES,
  TYPES,
  UPGRADE_VALUE_REFERENCE
} from './constants'

const RESERVE_PRICE_VALUE = 5
const RESERVE_PRICE_PERCENTAGE = 7.5
const MAX_RESERVE_PRICE_FEE = 250
const RESERVE_PRICE_HEAVY_EQUIPMENT = 5

const getValueUpgradesFee = (value, upgrades, reservePrice, insertionFee) => {
  const getFee = fees => {
    if (typeof fees === 'function') {
      return fees(value)
    }

    return value <= UPGRADE_VALUE_REFERENCE ? fees.lower : fees.higher
  }

  const valueUpgradesFee = upgrades.reduce((prev, curr) => prev + getFee(curr.fees, curr.type), 0)

  if (upgrades.find(({ type }) => type === AUCTION_UPGRADES_TYPES.TWO_CATEGORIES)) {
    return (valueUpgradesFee + reservePrice + insertionFee) * 2
  }

  return valueUpgradesFee + reservePrice + insertionFee
}

const getFinalValueFee = (closingPrice, shippingPrice, category, store) => {
  const {
    fees: {
      finalValue: { percentage, maximumFee },
      stores
    }
  } = category

  const finalValue = closingPrice + shippingPrice
  // const isClothingWithHigherValue = category.type === CATEGORIES_TYPES.CLOTHING && finalValue > 100

  if (store.type !== STORE_TYPES.NONE) {
    const {
      [store.type]: { percentage: percentageStore, maximumFee: maximumFeeStore }
    } = stores

    const finalValueFee = (finalValue * percentageStore) / 100

    return finalValueFee > maximumFeeStore ? maximumFeeStore : finalValueFee
  }

  const finalValueFee = (finalValue * percentage) / 100

  return finalValueFee > maximumFee ? maximumFee : finalValueFee
}

const getReservePrice = (reservePrice, category) => {
  if (reservePrice === 0) return reservePrice
  if (category.type === CATEGORIES_TYPES.HEAVY_EQUIPMENT) return RESERVE_PRICE_HEAVY_EQUIPMENT

  const valueByPercentage = (reservePrice * RESERVE_PRICE_PERCENTAGE) / 100
  const reservePriceFee =
    valueByPercentage > RESERVE_PRICE_VALUE ? valueByPercentage : RESERVE_PRICE_VALUE

  return reservePriceFee > MAX_RESERVE_PRICE_FEE ? MAX_RESERVE_PRICE_FEE : reservePriceFee
}

const getInsertionFee = (store, calculationType, categoryInsertionFee) => {
  if (store.insertionFee[calculationType] === 0) {
    return categoryInsertionFee
  }

  return store.insertionFee[calculationType]
}

// Tratar as lojas - insertion fee
export const calculateAuctionStyleFee = ({
  values,
  freeInsertionFee,
  category,
  upgrades,
  store
}) => {
  const insertionFee = freeInsertionFee
    ? 0
    : getInsertionFee(store, TYPES.AUCTION, category.fees.insertion)
  const finalValueFee = getFinalValueFee(values.closingPrice, values.shippingPrice, category, store)
  const reservePrice = getReservePrice(values.reservePrice, category)
  const valueUpgradesFee = getValueUpgradesFee(
    values.startingPrice,
    upgrades,
    reservePrice,
    insertionFee
  )

  const totalFees = finalValueFee + valueUpgradesFee

  return +totalFees.toFixed(2)
}
